import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'ion-modal-header',
  imports: [],
  templateUrl: './modal-header.component.html',
  styleUrls: ['./modal-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalHeaderComponent {
  readonly title = input('');
  readonly subtitle = input('');
}
